import React, { FC } from "react";
import type { PlatformHeroProps } from "@/types";
import { Image } from "../image";
import { TextCols } from "../text-cols";

export const PlatformHero: FC<PlatformHeroProps> = ({
  label,
  title,
  description,
  cover,
}) => {
  return (
    <section className="platformHero">
      <div className="wrapper">
        <TextCols
          label={label}
          content={{
            title,
            textCol1: description,
          }}
          singleCol
          size="lg"
          headingLevel="h1"
          maxTitleWidth={937}
        />
      </div>
      <div className="wrapper wrapper_lg">
        <div className="platformHero--cover-wrapper">
          {cover.file?.url && (
            <Image
              loading="eager"
              fetchPriority="high"
              className="platformHero--cover"
              src={cover as any}
              alt={cover.title}
              animateInView
              options={{
                sizes: {
                  exec: [
                    {
                      width: 1440,
                      height: 594,
                    },
                  ],
                },
              }}
            />
          )}
        </div>
      </div>
    </section>
  );
};
